import { render, staticRenderFns } from "./nba-list.vue?vue&type=template&id=f393977a&scoped=true"
import script from "./nba-list.vue?vue&type=script&lang=js"
export * from "./nba-list.vue?vue&type=script&lang=js"
import style0 from "./nba-list.vue?vue&type=style&index=0&id=f393977a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f393977a",
  null
  
)

export default component.exports